import { render, staticRenderFns } from "./CrifAnalysis.vue?vue&type=template&id=02a36dc4&"
import script from "./CrifAnalysis.vue?vue&type=script&lang=js&"
export * from "./CrifAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports